import { storage } from '@annunciate/core/dist/store/mmkv-store';
export const fetchKeys = async (cacheKey, uuid) => {
    if (!uuid)
        return [];
    const keys = storage.getAllKeys();
    const prefix = `@${cacheKey}:${uuid}:`;
    return keys.filter((key) => key.startsWith(prefix));
};
//# sourceMappingURL=fetchKeys.js.map